import React from 'react';
import {Card, Grid, Icon, Table} from 'semantic-ui-react';
import KatashikiesModal from './modals/katashikies/katashikiesModal';

const ComboKatashikisTab = ({comboKatashikies, handleComboKatashikies, editComboAccessory}) => {
  const isSelected = (vehicle) => {
    const katashikiSelected = comboKatashikies.find((x) => x.masterCode === vehicle.masterCode);
    return katashikiSelected ? true : false;
  };

  return (
    <Grid>
      <Grid.Row columns={3} textAlign='left'>
        <Grid.Column>
          <KatashikiesModal handleComboKatashikies={handleComboKatashikies}
            isSelected={isSelected} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Card fluid raised>
            <Table textAlign='center'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell content='Master' />
                  <Table.HeaderCell content='Segmento' />
                  <Table.HeaderCell content='Descripción' />
                  <Table.HeaderCell></Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {comboKatashikies.map((katashiki, i) => {
                  return (
                    <Table.Row key={i}>
                      <Table.Cell content={katashiki.masterCode} />
                      <Table.Cell content={katashiki.suffix} />
                      <Table.Cell content={katashiki.carModel} />
                      <Table.Cell content={
                        <Icon name='trash' link size='large' color='red'
                          onClick={(e) => handleComboKatashikies(e, katashiki)} />} />
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </Card>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default ComboKatashikisTab;

